import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  invitacionesActivas: [],
  invitacionesRechazadas: [],
  invitacionesPasadas: [],
  invitacionesActivasHasNextPage: false,
  invitacionesRechazadasHasNextPage: false,
  invitacionesPasadasHasNextPage: false,
  invitacionesActivasCurrentPage: 0,
  invitacionesRechazadasCurrentPage: 0,
  invitacionesPasadasCurrentPage: 0,

  invitacionDetalle: null,

  solicitudesEvento: [],
  solicitudesEventoLoading: false,

  miSolicitudEnEvento: null,
  crearSolicitudLoading: false,

  isLoadingInvitacion: false,
  failureInvitacion: false,
  errorInvitacion: null,
  errorStatusInvitacion: null,
};

const invitacionSlice = createSlice({
  name: "invitacion",
  initialState,
  reducers: {
    invitacionSuccess: (state, action) => {
      if (action.payload.invitacionesActivas !== undefined) {
        const { data, hasNextPage, currentPage, isFirstPage } = action.payload.invitacionesActivas;
        if (isFirstPage) {
          state.invitacionesActivas = data;
        } else {
          state.invitacionesActivas = [...state.invitacionesActivas, ...data];
        }
        state.invitacionesActivasHasNextPage = hasNextPage;
        state.invitacionesActivasCurrentPage = currentPage;
      }
      if (action.payload.invitacionesRechazadas !== undefined) {
        const { data, hasNextPage, currentPage, isFirstPage } = action.payload.invitacionesRechazadas;
        if (isFirstPage) {
          state.invitacionesRechazadas = data;
        } else {
          state.invitacionesRechazadas = [...state.invitacionesRechazadas, ...data];
        }
        state.invitacionesRechazadasHasNextPage = hasNextPage;
        state.invitacionesRechazadasCurrentPage = currentPage;
      }
      if (action.payload.invitacionesPasadas !== undefined) {
        const { data, hasNextPage, currentPage, isFirstPage } = action.payload.invitacionesPasadas;
        if (isFirstPage) {
          state.invitacionesPasadas = data;
        } else {
          state.invitacionesPasadas = [...state.invitacionesPasadas, ...data];
        }
        state.invitacionesPasadasHasNextPage = hasNextPage;
        state.invitacionesPasadasCurrentPage = currentPage;
      }
      if (action.payload.invitacionDetalle !== undefined) {
        state.invitacionDetalle = action.payload.invitacionDetalle;
      }
      if (action.payload.solicitudesEvento !== undefined) {
        state.solicitudesEvento = action.payload.solicitudesEvento;
      }
      if (action.payload.miSolicitudEnEvento !== undefined) {
        state.miSolicitudEnEvento = action.payload.miSolicitudEnEvento;
      }
      if (action.payload.solicitudesEventoLoading !== undefined) {
        state.solicitudesEventoLoading = action.payload.solicitudesEventoLoading;
      }
      if (action.payload.crearSolicitudLoading !== undefined) {
        state.crearSolicitudLoading = action.payload.crearSolicitudLoading;
      }
      state.failureInvitacion = false;
      state.isLoadingInvitacion = false;
    },
    invitacionFailure: (state, action) => {
      state.failureInvitacion = true;
      state.isLoadingInvitacion = false;
      if (typeof action.payload === "string") {
        state.errorInvitacion = action.payload;
        state.errorStatusInvitacion = null;
      } else {
        state.errorInvitacion = action.payload?.message || action.payload;
        state.errorStatusInvitacion = action.payload?.status || null;
      }
    },
    invitacionReset: () => {
      return { ...initialState };
    },
    setSolicitudesEvento: (state, action) => {
      state.solicitudesEvento = action.payload;
    },
  },
});

export const {
  invitacionSuccess,
  invitacionFailure,
  invitacionReset,
  setSolicitudesEvento,
} = invitacionSlice.actions;
export default invitacionSlice.reducer;
